export const SIGNUP_LOGIN_E2E_TEST_IDS = Object.freeze({
  COMPLETE_INFO_EMAIL_SKIP_BUTTON: 'complete-info-email-skip_button',
  COMPLETE_INFO_MOBILE_SKIP_BUTTON: 'complete-info-mobile-skip_button',
  FILL_INFO_SIGN_UP_BACK_BUTTON: 'fill-info-sign-up-back_button',
  LOGIN_FORGOT_PASSWORD_LINK: 'login-forgot-password_link',
  LOGIN_SIGN_UP_BUTTON: 'login-sign-up_button',
  REGISTER_STATUS_CONTINUE_SIGN_UP_BUTTON:
    'register-status-continue-sign-up_button',
  REGISTER_STATUS_SIGN_IN_BUTTON: 'register-status-sign-in_button',
  SIGNUP_SUBSCRIPTION_LINE_BUTTON: 'signup-subscription_button--line',
  SIGN_UP_PRIVACY_POLICY_LINK: 'sign-up-privacy-policy_link',
  SIGN_UP_TERMS_OF_USE_LINK: 'sign-up-terms-of-use_link',
  SMS_VERIFICATION_BACK_BUTTON: 'sms-verification-back_button',
});

export const getOAuthApplicationLinkE2eId = (clientId) =>
  `oauth-application_link--${clientId}`;
